import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ImageViewerService {
  private images$: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);

  getImages(): Observable<string[]> {
    return this.images$.asObservable();
  }

  setImages(images: string[], index?: number): void {
    if (index !== undefined && index >= 0 && index < images.length) {
      const reordered: string[] = [...images.slice(index), ...images.slice(0, index)];
      this.images$.next(reordered);
    } else {
      this.images$.next(images);
    }
  }
}
